import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReservationsListPanel } from "../Reservations/components/ReservationsListPanel/ReservationsListPanel";
import PageContainer from "../../Components/PageContainer/PageContainer";
import { ControlledCustomSelect } from "../../Components/formComponents";
import { useNavigate, useParams } from "react-router-dom";
import { TABLES_LAYOUT_ROUTE } from "./Tables.constants";
import { ICustomTableNode } from "../../Components/ReactFlowShapes/ReactFlowShapes.types";
import { ReactFlowShapesView } from "../../Components/ReactFlowShapes/ReactFlowShapesView";
import { TableBottom } from "./components/TableBottom";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import { clearTablesLayoutStateSync, defaultTablesLayout, fetchOutletSingleLayoutAsync, upsertSingleTableLayoutAsync } from "../../redux/tables";
import { useOutletContext } from "../../providers";
import TableLayoutTabs from "./TableLayoutTabs";
import { CreateNewLayoutButton } from "./dialogs/CreateNewLayoutButton";
import { ViewSingleLayout } from "./ViewSingleLayout";
import { TableMenuLayout } from "./TableMenuLayout";

export const Tables: React.FC = () => {
  const [editableMode, setEditableMode] = useState(false)
  return (
    <PageContainer title="Tables" description="Tables page">
      {<TableLayoutTabs />}
      {editableMode ? <TableMenuLayout onModeChange={() => setEditableMode(prev => !prev)} /> : <ViewSingleLayout onModeChange={() => setEditableMode(prev => !prev)} />}
      
    </PageContainer>
  );
};
